import React from 'react'
import { Link } from 'react-router-dom'
import './homegee.css'

const Homeg = () => {
  return (
    <div>
      <Link to='/'  className='fa fa-arrow-left'> <span></span>
       </Link>
    </div>
  );
}

export default Homeg
